import React from 'react'

import { Input } from './Input'

type Props = {
  /**
   * The value that needs to be typed in to confirm the action.
   */
  value: string
  /**
   * A callback to update the current match state
   */
  onMatch: (match: boolean) => void
  /**
   * An optional callback to render the confirmation prompt.
   */
  confirmationRenderer?: () => React.ReactNode
}

export function InputConfirmation({
  value,
  onMatch,
  confirmationRenderer,
}: Props) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onMatch(event.target.value === value)
  }

  const renderPrompt = () => {
    if (confirmationRenderer) {
      return confirmationRenderer()
    }

    return (
      <p className="text-gray-500 dark:text-gray-400">
        To confirm, type &quot;
        <span className="font-medium text-gray-700 dark:text-gray-200">
          {value}
        </span>
        &quot; into the box below
      </p>
    )
  }

  return (
    <div>
      {renderPrompt()}
      <Input
        id="confirmationInput"
        className="mt-1.5"
        onChange={handleChange}
        placeholder={value}
        data-testid="confirmationInput"
      />
    </div>
  )
}
